// Shared plan catalog constants (pricing/features mirror backend for display).
export const PLANS = {
  sole_trader: [
    {
      id: "starter",
      name: "Starter",
      price: 59,
      tagline:
        "For non-GST contractors on schedular payments — typically one client, one invoice recipient.",
      features: [
        "Monthly tax position email",
        "Prosaic subscription",
        "Simple invoicing in Prosaic",
        "End-of-year tax return included",
        "Email support (48h response)",
      ],
      highlight: false,
    },
    {
      id: "growth",
      name: "Growth",
      price: 75,
      tagline:
        "For GST-registered contractors on schedular payments — typically one client, one invoice recipient.",
      features: [
        "Everything in Starter",
        "Monthly Prosaic review & categorisation",
        "GST return preparation & filing",
        "Simple invoicing in Prosaic",
        "Priority email support (24h)",
      ],
      highlight: true,
    },
    {
      id: "premium",
      name: "Premium",
      price: 149,
      tagline: "For sole traders with multiple customers — hands-off tax & bookkeeping.",
      features: [
        "Everything in Growth",
        "Full monthly bookkeeping in Prosaic",
        "Provisional tax planning",
        "Monthly strategy call (45 min)",
        "Priority email support (12h)",
      ],
      highlight: false,
    },
  ],
  company: [
    {
      id: "essential",
      name: "Essential",
      price: 149,
      tagline: "For new NZ companies keeping it lean.",
      features: [
        "Monthly tax position email",
        "Annual financial statements",
        "Income tax return (IR4)",
        "GST returns (2-monthly)",
        "Xero advisor partnership",
      ],
      highlight: false,
    },
    {
      id: "professional",
      name: "Professional",
      price: 249,
      tagline: "For typical 1–2 shareholder companies that want clarity.",
      features: [
        "Everything in Essential",
        "Monthly management accounts",
        "Payroll up to 5 employees",
        "Quarterly strategy & tax planning call",
        "Up to 2 Shareholders",
      ],
      highlight: true,
    },
    {
      id: "enterprise",
      name: "Enterprise",
      price: 499,
      tagline: "For companies with 3+ shareholders — full outsourced finance for scale.",
      features: [
        "Everything in Professional",
        "Full monthly bookkeeping in Xero",
        "Payroll up to 20 employees",
        "Monthly CFO-style review call",
        "3 or more Shareholders",
        "Priority IRD correspondence handling",
        "Unlimited ad-hoc tax advice",
      ],
      highlight: false,
    },
  ],
};

export const ENTITY_LABEL = {
  sole_trader: "Sole Trader",
  company: "Company",
};
